import Main from '../views/Main.vue';

const Generator = () => import('../views/main/Generator.vue');

const Auth = () => import('../views/Auth.vue');
const AuthCallback = () => import('../views/AuthCallback.vue');

const NotFound = () => import('../views/NotFound.vue');

export default [
  {
    path: '/',
    name: 'main',
    component: Main,
    redirect: { name: 'generator' },
    meta: { requiresAuth: true },
    children: [{
      path: 'generator',
      name: 'generator',
      component: Generator,
    }],
  }, {
    path: '/auth',
    name: 'auth',
    component: Auth,
    meta: { requiresAnon: true },
  }, {
    path: '/auth/callback',
    name: 'authCallback',
    component: AuthCallback,
    meta: { requiresAnon: true },
  }, {
    path: '/404',
    name: 'notFound',
    component: NotFound,
  }, {
    path: '*',
    redirect: { name: 'notFound' },
  },
];
